import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import React from "react"
import { useInView } from "react-intersection-observer"
import styled from "styled-components"

const Container = styled.div<{ $scale: 1 | 2 }>`
  margin: ${({ $scale }) => ($scale === 1 ? "10vh 0" : 0)};
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    justify-content: center;
    display: flex;
    width: 100%;
    height: auto;
  }
`

const ZoomedImage = React.forwardRef((props: any, ref: any) => {
  const { inView, ref: viewRef } = useInView({ threshold: 0.65 })

  React.useEffect(() => {
    if (inView) {
      props.toggleActive()
    }
  }, [inView])

  return (
    <Container $scale={props.scale} ref={ref}>
      <div ref={viewRef}>
        <ImageWrapper>
          <ImageHelper
            alt={props.alt || "Zoomed product image"}
            src={props.image}
          />
        </ImageWrapper>
      </div>
    </Container>
  )
})

export default ZoomedImage
